export enum SyndicationStatus {
  Pending = "pending",
  Registered = "registered",
  Participating = "participating",
  Expired = "expired",
}
